import "../../Styles/ClientPayment.css";

function ClientPayment({ btnLoading, CreateClient }) {
  return (
    <div className="client-payment-main-wrapper">
      <div className="client-payment-card-wrapper">
        <div className="client-payment-inside-wrapper">
          {/* TOP SECTION */}
          <div className="client-payment-top-section">
            <h2>Individual Plan</h2>

            <p>Complete your membership to access all WedLuk features.</p>

            <div className="client-payment-top-line"></div>
          </div>

          {/* PLAN CARD */}
          <div className="client-payment-plan-card">
            <div className="client-payment-plan-top">
              <div className="client-payment-plan-left">
                <div className="client-payment-diamond-icon pt-2">
                  {" "}
                  <img
                    src={require("../../assests/images/payment_icon.png")}
                    alt=""
                    className="success-icon-img"
                  />
                </div>

                <div>
                  <h4>Annual Membership</h4>

                  <h3>
                    ₹ 0/year
                    <span> ₹ 699/year</span>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client-payment-plan-bottom">
              <div className="client-payment-coupon">
                <span>Coupon applied:</span>

                <div>EARLY-MEMBER ✕</div>
              </div>

              <div
                className="client-payment-start-btn"
                onClick={!btnLoading ? CreateClient : undefined}
              >
                {btnLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading...
                  </>
                ) : (
                  <>
                    Start Plan <span>›</span>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* FEATURES */}
          <div className="client-payment-feature-grid">
            <div className="client-payment-feature-card">
              <h3>✥ Smart Matchmaking</h3>

              <ul>
                <li>AI-powered compatible matches</li>
                <li>Verified profiles</li>
                <li>Mutual connection insights</li>
              </ul>
            </div>

            <div className="client-payment-feature-card">
              <h3>✥ Collaborative Matchmaking</h3>

              <ul>
                <li>Create/manage multiple profiles</li>
                <li>Invite family members</li>
                <li>Collaborate on finding matches together</li>
              </ul>
            </div>

            <div className="client-payment-feature-card">
              <h3>✥ Privacy & Control</h3>

              <ul>
                <li>Privacy-first profile visibility</li>
                <li>Blurred photos & selective access</li>
                <li>Full control over interactions</li>
              </ul>
            </div>

            <div className="client-payment-feature-card">
              <h3>✥ Agent-Assisted Matchmaking</h3>

              <ul>
                <li>
                  Work with matrimony agents digitally with WedLuk's
                  collaboration tools.
                </li>

                <li>Upgrade to agent-assisted matchmaking anytime</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientPayment;
